class CartNotifRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-notification').removeItem(event.target);
    });
  }
}

customElements.define('cart-notif-remove-button', CartNotifRemoveButton);

class QuantityNotificationInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
     this.querySelectorAll('[name="updates[]"]').forEach((quanty) =>{
    console.log(quanty)
    quanty.addEventListener('change', this.closest('cart-notification').updateItems(quanty))});
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}
customElements.define('quantity-notification-input', QuantityNotificationInput);






var cart = document.querySelector('.cart_wrap');
var cartBtn = document.querySelector('.cart-button');
  	cartBtn.addEventListener('click', function (e) {
  		e.preventDefault();
  		document.querySelector('body').classList.add('cart-open');
    this.cartNotification = document.querySelector('cart-notification');
    this.cartNotification.setActiveElement(document.activeElement);
  let sections = this.cartNotification.getSectionsToRender().map((section) => section.id);
   var cartContents = fetch(`/cart.js?sections=${sections}`)
  .then(response => response.json())
  .then(data => { 
    console.log(data)
    this.cartNotification.renderContentsCart(data)
     });
  	});

    document.querySelector('.cart_wrap').querySelector('.cart-close').addEventListener('click', function (e) {
  		e.preventDefault();
  		document.querySelector('body').classList.remove('cart-open');
  	});
  	document.querySelector('.cart_wrap').querySelector('.cart-overlay').addEventListener('click', function (e) {
  		e.preventDefault();
  		document.querySelector('body').classList.remove('cart-open');
  	});




class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

  }

  open() {
    console.log('open NOTIf')
      this.notification.classList.add('animate', 'active');
      document.body.classList.add('cart-open');
      this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });
    document.body.addEventListener('click', this.onBodyClick);
    this.renderContentsCart();
  }

  close() {
    this.notification.classList.remove('active');
    document.body.classList.remove('cart-open');
    document.body.removeEventListener('click', this.onBodyClick);
    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    //console.log(parsedState);
    //console.log(parsedState.sections)
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      //if (this.header) this.header.reveal();
      this.open();
  }

  removeItem(evt){
    console.log(evt)
    const link = evt.closest('a').getAttribute('href')
    console.log( link )
    fetch(link)
    .then(response => {
    
   })
   this.renderContentsCart()
  }

  updateItems(quanty){
    if (quanty.value == 0){
    return
    }
   const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.body = JSON.stringify({
           'id': quanty.dataset.id,
  			'quantity': quanty.value,
          sections: this.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname
        });
 
        fetch('/cart/change.js', config)
          .then((response) => response.json())
          .then((response) => {
            
  			//console.log('ОТВЕТ')
          //  console.log(response)
  
         //   console.log(response.sections)
        //   this.getSectionsToRender().forEach((section => {
      // document.getElementById(section.id).innerHTML =
      //   this.getSectionInnerHTML(response.sections[section.id], section.selector);
     // }));
  
            response.id = quanty.dataset.id;
            console.log(response)
           	this.renderContents(response);
          })

  }

	renderContentsCart() {
    fetch('/cart.js?sections=header')
    .then(response => response.json())
    .then(data => {
      data.items.forEach((item=>{
        this.productId = item.id;
      fetch('/?sections=cart-asside-product,cart-notification-total,cart-notification-title')
      .then(response => response.json())
      .then(data => {
      document.getElementById('cart-asside-product').innerHTML = this.getSectionInnerHTML(data['cart-asside-product'] );
      //document.getElementById('cart-notification-title').innerHTML = this.getSectionInnerHTML(data['cart-notification-title'] );
      document.getElementById('cart-notification-total').innerHTML = this.getSectionInnerHTML(data['cart-notification-total'] )   
      });
      }));
  	})
  }





  getSectionsToRender() {
    return [
      {
        id: 'cart-asside-product'
      },
      // {
      //   id: 'cart-notification-title'
      // },
      {
        id: 'cart-icon-bubble'
      },
      {
        id: 'cart-notification-total'
      }
      
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
   // else{
      
   //   this.querySelectorAll('[name="updates[]"]').forEach((quanty) =>{
     // console.log(quanty)
     // quanty.addEventListener('change', this.updateItems(quanty))});
    
      
      
     //  this.querySelectorAll('cart-remove-button a svg ').forEach((a) =>{
     // if (target == a){
      
     //  this.removeItem(evt)
    //  }});
     
     
     
    //}
    
    
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}


customElements.define('cart-notification', CartNotification);


document.addEventListener('DOMContentLoaded', function(){
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
if (links[i].hostname !== window.location.hostname) {
links[i].target = '_blank';
links[i].rel = 'noreferrer noopener';
}
}
});